import React from 'react';
import { Dna, Globe } from 'lucide-react';
export function GeneticAI() {
  return <section className="py-24 px-6 md:px-12 lg:px-24 bg-white" data-id="element-498">
      <div className="max-w-7xl mx-auto" data-id="element-499">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-500">
          <h2 className="text-4xl md:text-6xl font-bold mb-6" data-id="element-501">
            Generic AI vs. <span className="text-[#0066FF]" data-id="element-502">Genetic AI</span>
          </h2>
          <p className="text-xl text-gray-600 font-light" data-id="element-503">
  Stop wasting tokens on guesses. LLM&apos;s are rapidly becoming 
  interchangeable utilities. They own the compute. <span className="font-bold text-gray-900" data-id="element-504">You own the logic.</span>
        </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-505">
  {/* Generic AI Side */}
  <div className="p-12 bg-gray-50 border border-gray-200 rounded" data-id="element-506">
    <div className="flex items-center gap-3 mb-6" data-id="element-507">
      <Globe className="w-6 h-6 text-gray-400" data-id="element-508" />
      <h3 className="text-2xl font-bold text-gray-500" data-id="element-509">Generic AI</h3>
    </div>
    <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-510">
      A well-read intern. Knows the material, follows patterns, but lacks the situational judgment of your firm.
    </p>
    <div className="h-1 w-full bg-gray-200 rounded-full overflow-hidden" data-id="element-511">
      <div className="h-full w-1/3 bg-gray-400" data-id="element-512"></div>
    </div>
  </div>
  
  {/* Genetic AI Side */}
  <div className="p-12 bg-white border border-gray-200 rounded relative overflow-hidden" data-id="element-513">
    <div className="absolute top-0 right-0 w-32 h-32 bg-[#0066FF] opacity-5 blur-[60px] rounded-full" data-id="element-514"></div>
    <div className="flex items-center gap-3 mb-6 relative z-10" data-id="element-515">
      <Dna className="w-6 h-6 text-[#0066FF]" data-id="element-516" />
      <h3 className="text-2xl font-bold text-black" data-id="element-517">Genetic AI</h3>
    </div>
    <p className="text-lg text-black mb-8 leading-relaxed relative z-10" data-id="element-518">
      A seasoned professional trained inside your organization. Applies your standards, judgment, and institutional memory by default.
    </p>
    <div className="h-1 w-full bg-gray-100 rounded-full overflow-hidden" data-id="element-519">
      <div className="h-full w-full bg-[#0066FF]" data-id="element-520"></div>
    </div>
  </div>
      </div>

        {/* Wisdom Moat */}
        <div className="mt-20 p-8 md:p-12 bg-black text-white rounded" data-id="element-521">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center" data-id="element-522">
            <div className="lg:col-span-1" data-id="element-523">
              <h3 className="text-3xl font-bold font-['Syne'] text-[#0066FF]" data-id="element-524">
                The Instruction Layer
              </h3>
            </div>
            <div className="lg:col-span-2" data-id="element-525">
              <p className="text-lg text-gray-300 leading-relaxed" data-id="element-526">
                Your reasoning logic is Enterprise IP. It gives you{' '}
                <strong className="text-white" data-id="element-527">Model Independence</strong>.
                Synthia sits as an independent Instruction Layer, so you
                can swap the underlying 'Generic' model (OpenAI, Anthropic,
                Gemini) in an afternoon without losing a single drop of your
                organization's unique intelligence.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}